/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import Color from "../../theme/color";
import { useEffect, useState } from "react";
import { POST } from "../../config/https";
import APIS from "../../config/api";
import { GetLocalStorage } from "../../utils/local-storage";
import { Icon } from "@iconify/react";
import FullScreenLoader from "../../components/full-screen-loader";
import toast from "react-hot-toast";

type TicketData = {
  orderId: string;
  ticketType: string;
  email: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zipCode: number;

  date: string;
  id: number;
  createdBy: number | null;
  createdDate: string;
  modifiedBy: number | null;
  modifiedDate: string | null;
  eventName: string;
  image: any;
  orderNo: string;
  checkIn: boolean;
};

const ViewTicket = () => {
  const [loader, setLoader] = useState(false);
  const [ticketData, setTicketData] = useState<TicketData>({
    orderId: "",
    ticketType: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zipCode: 0,
    country: "",
    date: "",
    id: 0,
    createdBy: 0,
    createdDate: "",
    modifiedBy: null,
    modifiedDate: null,
    eventName: "",
    image: "",
    orderNo: "",
    checkIn: false,
  });

  useEffect(() => {
    Ticket();
  }, []);

  let customerId = GetLocalStorage("customerId");
  const Ticket = async () => {
    setLoader(true);
    await POST(APIS.TICKET_BY_ID + "?id=" + customerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setTicketData(res?.result);
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const HandleCheckIn = async () => {
    setLoader(true);
    await POST(APIS.TICKET_CHECK_IN + "?id=" + customerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          Ticket();
        } else {
          toast.error(res?.errors);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <Grid
      xs={12}
      sm={8}
      md={4}
      container
      justifyContent="center"
      alignItems="center"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "20px",
        backgroundColor: "#f5f5f5",
        borderRadius: "5px",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        width: "90%",
        margin: "auto",
        marginTop: "10px",
        marginBottom: "10px",
        overflowX: "auto",
        height: "auto",
      }}
    >
      <FullScreenLoader open={loader} />
      <div
        style={{
          filter: "drop-shadow(1px 1px 3px rgba(0, 0, 0, 0.3))",
          width: "100%",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src={ticketData?.image}
            alt=""
            style={{ width: "100%", height: "auto" }}
          />

          <TableContainer>
            <Table style={{ minWidth: "100%", tableLayout: "auto" }}>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    <form method="post" action="">
                      <input type="hidden" name="action" value="checkIn" />
                      <input type="hidden" name="u_id" value="19718" />
                    </form>
                    <Typography
                      variant="h5"
                      style={{
                        fontWeight: "bold",
                        fontFamily: "'Lato', sans-serif",
                        display: "flex",
                        flexDirection: "column",
                        color: Color.primary,
                      }}
                    >
                      {ticketData?.eventName}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Ticket No</TableCell>
                  <TableCell style={Styles.tableCellText}>
                    {ticketData?.id}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Date</TableCell>
                  <TableCell style={Styles.tableCellText}>
                    {ticketData?.date}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Order No</TableCell>
                  <TableCell style={Styles.tableCellText}>
                    {ticketData?.orderNo}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Email</TableCell>
                  <TableCell style={Styles.tableCellText}>
                    {ticketData?.email}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Address</TableCell>
                  <TableCell style={Styles.tableCellText}>
                    {ticketData?.address}, {ticketData?.city},{" "}
                    {ticketData?.state}, {ticketData?.country},{" "}
                    {ticketData?.zipCode}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Ticket Type</TableCell>
                  <TableCell style={Styles.tableCellText}>
                    {ticketData?.ticketType}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={Styles.tableCell}>Check in:</TableCell>
                  <TableCell>
                    {ticketData?.checkIn === false ? (
                      <Icon
                        icon="fa6-solid:x"
                        color="red"
                        width="40"
                        height="30"
                      />
                    ) : (
                      <Icon
                        icon="simple-icons:nike"
                        color="#2eb82e"
                        width="50"
                        height="50"
                      />
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div
          style={{
            backgroundColor: "white",
            height: "20px",
            margin: "0 10px",
            backgroundImage:
              "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAACCAYAAAB7Xa1eAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuOWwzfk4AAAAaSURBVBhXY5g7f97/2XPn/AcCBmSMQ+I/AwB2eyNBlrqzUQAAAABJRU5ErkJggg==)",
            backgroundSize: "4px 2px",
            backgroundRepeat: "repeat-x",
            backgroundPosition: "center",
            position: "relative",
            boxShadow: "0 1px 0 0 #fff, 0 -1px 0 0 #fff",
          }}
          className="rip"
        ></div>
        <div
          style={{
            backgroundColor: "#fff",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
            height: "60px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={HandleCheckIn}
            style={{
              padding: "10px 20px",
              fontSize: 15,
              fontWeight: "bold",
              textAlign: "center",
              background: "#056505",
              color: "#fff",
              border: 0,
              cursor: "pointer",
            }}
            variant="contained"
            type="submit"
          >
            Check In
          </Button>
        </div>
      </div>
    </Grid>
  );
};

export default ViewTicket;

const Styles: any = {
  tableCell: {
    // textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
  },
  tableCellText: {
    // textAlign: "center",
    fontSize: 15,
  },
};
